import { Module } from 'vuex'
import { RootState } from '@/store'
import { actions } from '@/store/ui/actions'
import { mutations } from '@/store/ui/mutations'

export interface UiState {
    minimalizedNav: boolean,
    collapsableActive: boolean,
}

const state: UiState = {
    minimalizedNav: true,
    collapsableActive: false,
}

export const UiModule: Module<UiState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
}
